import { render, staticRenderFns } from "./setSettingsIphone.vue?vue&type=template&id=72806fc8&scoped=true&"
import script from "./setSettingsIphone.vue?vue&type=script&lang=js&"
export * from "./setSettingsIphone.vue?vue&type=script&lang=js&"
import style0 from "./setSettingsIphone.vue?vue&type=style&index=0&id=72806fc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72806fc8",
  null
  
)

export default component.exports